module.exports = __webpack_public_path__ + "img/logo-blue.782bdce7.svg";